<template>
  <div>
    <div class="maintitle">{{ $route.meta.title }}</div>
    <el-divider></el-divider>
    <el-row :gutter="10" class="text-left">
      <el-col :span='6'>
        <el-select v-model="type" style="width:100%">
          <el-option v-for="(item,index) in typeList" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </el-col>
      <el-button @click="getTemplate">查看</el-button>
    </el-row>
    <el-table :data="list" border>
      <el-table-column prop="title" label="模板名"></el-table-column>
      <el-table-column label="状态" :formatter="formatStatus"></el-table-column>
      <el-table-column label="操作"></el-table-column>
    </el-table>
<!--    <el-form :label-width="formLabelWidth">-->
<!--      <el-form-item label="模板名">-->
<!--        <el-input v-model="info.title"></el-input>-->
<!--      </el-form-item>-->
<!--        <div>考核项</div>-->
<!--        <div v-for="(item,index) in info.detail" :key="index">-->
<!--&lt;!&ndash;          <el-form-item label=""&ndash;&gt;-->
<!--        </div>-->
<!--    </el-form>-->
  </div>
</template>
<script>
export default {
  data() {
    return {
      type:1,
      typeList:[],
      list:[],
      info:{}
    }
  },
  methods: {
    getTemplate() {
      this.$axios({
        url:this.HOST+'/kaohe/setting/excellentTemplate',
        method:'post',
        data:{
          type:this.type,
        }
      }).then((res) => { console.log(res)
        if(res.data.status === 1){
          this.list = res.data.list;
        }else{
          this.$message.error(res.data.info)
        }
      })
    },
    formatStatus(row){
      return row.status === 1?'正常':'停用'
    }
  },
  mounted() {
    this.$axios({
      url:this.HOST+'/kaohe/index/getCommonInfo',
      method:'post',
      data:{
        info:['employeeType'],
      }
    }).then((res)=>{
      if(res.data.status === 1){
        this.typeList = res.data.employeeType;
      }
    })
  }
}
</script>
<style>

</style>